//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import ServiceCard from "~/components/select-service-register/ServiceCard.vue";
import Pagination from "~/components/common/Pagination.vue";

export default BaseCmsBlock.extend({

  data: function () {
    return {
      services: [],
      licenseAgentItems: [],

      filter: {
        'page': 1,
        'per-page': 5,
        'filter[name][like]': '',
        'filter[service_id]': '',
      },

      totalItems: 1,
      totalPages: 1,

      isLoadServices: true,
      isLoadLicense: true,
      timeOutSearch: null
    }
  },

  computed: {
    title: function () {
      return this.values?.title || ''
    },
  },

  components: {
    Pagination,
    ServiceCard
  },

  mounted: async function () {
    await this.getServices();
    await this.getLicenseAgentItems();
  },

  methods: {

    getServices: async function () {
      this.services = await this.$api.agent.transport.get('/license-agent-items/services').then((res) => {
        return res.data || []
      }).catch(() => {
        return []
      });
      this.isLoadServices = false;
    },
    getLicenseAgentItems: async function () {
      this.isLoadLicense = true;
      const filterObj = {...(this.filter || {})};
      let filterStr = [
        'expand=services'
      ];
      Object.keys(filterObj).map((filterKey) => {
        const filterValue = filterObj[filterKey];
        if (!!filterValue) {
          filterStr.push(`${ filterKey }=${ filterValue }`);
        }
      });

      const res = await this.$api.agent.transport.get(`/license-agent-items?${ filterStr.join('&') }`).then((res) => {
        return {
          data: res.data || [],
          totalPages: Number.parseFloat(res?.headers?.['x-pagination-page-count'] || 1),
          totalItems: Number.parseFloat(res?.headers?.['x-pagination-total-count'] || 0),
        }
      }).catch(() => {
        return {
          data: [],
          totalPages: 1,
          totalItems: 0,
        }
      });

      this.isLoadLicense = false;
      this.totalPages = res.totalPages;
      this.totalItems = res.totalItems;
      this.licenseAgentItems = res.data;
    },


    changeFilter: async function ({ name, value }, isFast = false) {
      clearTimeout(this.timeOutSearch);

      let filter = {...this.filter};
      filter[name] = value;
      this.filter = filter;

      this.timeOutSearch = setTimeout(async () => {
        await this.getLicenseAgentItems();
      }, Boolean(isFast) ? 0 : 1000)
    },
    changeFilterName: async function (event) {
      await this.changeFilter({
        name: 'filter[name][like]',
        value: event.target.value || ''
      });
    },
  }

});
